export default "__VITE_ASSET__CEAwdiWn__"